var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "span",
    { staticClass: "gfu-creators-line", attrs: { "data-qa": "creator-names" } },
    [
      !_vm.hidePrefix
        ? _c("span", { staticClass: "gfu-creators-line__prefix" }, [
            _vm._v(_vm._s(_vm.Resources.Common.ByText) + " "),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "gfu-creators-line__name",
          attrs: { title: _vm.creator.name, "data-qa": "main-creator-name" },
        },
        [
          _vm.showAsLinks && _vm.creator.url
            ? _c(
                "a",
                { staticClass: "gfu-link", attrs: { href: _vm.creator.url } },
                [_vm._v(_vm._s(_vm.creator.name))]
              )
            : [_vm._v(_vm._s(_vm.creator.name))],
        ],
        2
      ),
      _vm._v(" "),
      _vm.hasOneCoCreator
        ? [
            _c("span", { staticClass: "gfu-creators-line__separator" }, [
              _vm._v(" & "),
            ]),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass: "gfu-creators-line__name",
                attrs: {
                  title: _vm.firstCoCreator.name,
                  "data-qa": "co-creator-name",
                },
              },
              [
                _vm.showAsLinks && _vm.firstCoCreator.url
                  ? _c(
                      "a",
                      {
                        staticClass: "gfu-link",
                        attrs: { href: _vm.firstCoCreator.url },
                      },
                      [_vm._v(_vm._s(_vm.firstCoCreator.name))]
                    )
                  : [_vm._v(_vm._s(_vm.firstCoCreator.name))],
              ],
              2
            ),
          ]
        : _vm.hasMultipleCoCreators
        ? _c("span", { attrs: { "data-qa": "other-creators" } }, [
            _vm._v(
              " +" +
                _vm._s(_vm.coCreators.length) +
                " " +
                _vm._s(_vm.Resources.Common.MoreText)
            ),
          ])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }